export enum VALIDATE_HOOK {
    BLUR = 'blur',
    CHANGE = 'change',
    SUBMIT = 'submit',
}
